/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Taxon } from '../models/Taxon';
import type { TaxonDetail } from '../models/TaxonDetail';
import type { TaxonGenus } from '../models/TaxonGenus';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TaxonService {

    /**
     * Taxon Filter
     * @returns Taxon Successful Response
     * @throws ApiError
     */
    public static taxonFilterApiV1TaxonFilterGet({
        heightMin,
        heightMax,
        widthMin,
        widthMax,
        sunAllowed,
        waterAllowed,
    }: {
        heightMin?: number,
        heightMax?: number,
        widthMin?: number,
        widthMax?: number,
        sunAllowed?: (string | null),
        waterAllowed?: (string | null),
    }): CancelablePromise<Array<Taxon>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/taxon/filter',
            query: {
                'height_min': heightMin,
                'height_max': heightMax,
                'width_min': widthMin,
                'width_max': widthMax,
                'sun_allowed': sunAllowed,
                'water_allowed': waterAllowed,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Taxon Search
     * @returns Taxon Successful Response
     * @throws ApiError
     */
    public static taxonSearchApiV1TaxonSearchGet({
        q = '',
    }: {
        q?: string,
    }): CancelablePromise<Array<Taxon>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/taxon/search',
            query: {
                'q': q,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Taxon Detail
     * @returns TaxonDetail Successful Response
     * @throws ApiError
     */
    public static taxonDetailApiV1TaxonDetailGet({
        q = '',
    }: {
        q?: string,
    }): CancelablePromise<TaxonDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/taxon/detail',
            query: {
                'q': q,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Taxon Genus
     * @returns TaxonGenus Successful Response
     * @throws ApiError
     */
    public static taxonGenusApiV1TaxonGenusGet({
        q = '',
    }: {
        q?: string,
    }): CancelablePromise<TaxonGenus> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/taxon/genus',
            query: {
                'q': q,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Taxon Detail
     * @returns any Successful Response
     * @throws ApiError
     */
    public static taxonDetailApiV1TaxonCsvPost({
        requestBody,
    }: {
        requestBody?: Array<string>,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/taxon/csv',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
